// extracted by mini-css-extract-plugin
export default {"newTask":"NewTask_newTask__qgNI1","newTaskIcon":"NewTask_newTaskIcon__ozwB4","newTaskTitle":"NewTask_newTaskTitle__YucbS"};